import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  clearCustomerPriceTables,
  getCustomerPriceTables,
} from 'domains/Customers/CustomerPriceTables/customerPriceTablesSlice';
import {
  getCustomerPriceTablesData,
  getCustomerPriceTablesStatus,
} from 'domains/Customers/CustomerPriceTables/customerPriceTablesSlice/customerPriceTablesSelectors';
import {
  trackingCustomerCreateAddPriceTables,
  trackingCustomerEditAddPriceTables,
  trackingCustomerEditRemovePriceTables,
} from 'domains/Customers/tracking';

export default function useCustomerPriceTables(id?: string) {
  const dispatch = useAppDispatch();

  const customerPriceTablesData = useSelector(getCustomerPriceTablesData);
  const customerPriceTablesStatus = useSelector(getCustomerPriceTablesStatus);

  const fetchCustomerPriceTables = useCallback(() => {
    if (id) {
      dispatch(getCustomerPriceTables(id));
    }
  }, [dispatch, id]);

  const resetCustomerPriceTables = useCallback(() => {
    dispatch(clearCustomerPriceTables());
  }, [dispatch]);

  const trackingPriceTables = useCallback(
    (selectedPriceTables: string[]) => {
      if (id && customerPriceTablesData.length > selectedPriceTables.length) {
        trackingCustomerEditRemovePriceTables(id);
      } else if (
        id &&
        customerPriceTablesData.length < selectedPriceTables.length
      ) {
        trackingCustomerEditAddPriceTables(id);
      } else if (!id && selectedPriceTables.length > 0) {
        trackingCustomerCreateAddPriceTables();
      }
    },
    [customerPriceTablesData, id],
  );

  return {
    customerPriceTablesData,
    customerPriceTablesStatus,
    fetchCustomerPriceTables,
    resetCustomerPriceTables,
    trackingPriceTables,
  };
}
